import { CheckoutField } from '@mews-distributor/common';

import { ApplicationState } from '../../../../types';
import { changeCustomerValue } from '../../slices';
import { connectCheckoutField } from '../../utils/connectCheckoutField';
import { getTermsAndConditionsLinks } from './selectors';

export const inject = connectCheckoutField({
    defaultName: CheckoutField.AgreeWithConditions,
    defaultValue: false,
    valueKey: 'checked',
    mapAdditionalProps: (state: ApplicationState) => ({
        links: getTermsAndConditionsLinks(state, {}),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'dispatch' implicitly has an 'any' type.
    mapAdditionalDispatchProps: (dispatch, { name }: $TSFixMe) => ({
        onChange: (_: $TSFixMe, checked: $TSFixMe) => dispatch(changeCustomerValue({ key: name, value: checked })),
    }),
});
